/**
 * Which status controls the Messages Planner header shows, keyed by viewport.
 *
 * DESKTOP keeps the full status row: the compact subscription pill, the
 * bot-status chip, and the connected-engines control (which also carries the
 * Connect-WhatsApp CTA and the Keep-Awake on/off toggle).
 *
 * MOBILE (< MOBILE_BREAKPOINT, i.e. useIsMobile()) collapses the header to the
 * burger + title and a SINGLE compact, tap-to-expand status chip — the
 * bot-status chip, which already folds the on/off toggle into a
 * collapsed-by-default popover. The subscription pill and the connected-engines
 * control are dropped because at 390px the three groups crammed the app-bar,
 * "Connect WhatsApp" duplicated the onboarding row's connect CTA, and the
 * subscription/billing nudges already surface through DunningBanner/NudgeBanner.
 *
 * Pure: no DOM, no hooks. The component passes useIsMobile() in and renders the
 * flags against the EXISTING header components + tokens — this adds no new
 * styling, it only gates what the shared header already renders.
 */
export interface HeaderStatusItems {
  /** the compact SubscriptionStatusBar pill */
  subscription: boolean;
  /** the BotStatusComponent chip (collapsed-by-default, tap to expand) */
  botStatus: boolean;
  /** the ConnectedEngines control (Connect-WhatsApp CTA + Keep-Awake toggle) */
  connectedEngines: boolean;
}

export function headerStatusItemsForViewport(
  isMobile: boolean,
  options: { bare?: boolean } = {},
): HeaderStatusItems {
  // Chromeless ("clear") surfaces show no status controls at all — the header
  // they live in isn't rendered there either.
  if (options.bare) {
    return { subscription: false, botStatus: false, connectedEngines: false };
  }
  if (isMobile) {
    return { subscription: false, botStatus: true, connectedEngines: false };
  }
  return { subscription: true, botStatus: true, connectedEngines: true };
}
